// `.env.json` is generated by the `npm run build` command
import env from './.env';
import { configuracion_radicacion_avanzada } from './radicacion_avanzada';

export const environment = {
  production: true,
  observationsExpediente: true,
  integrationCita: false,
  liquidationCita: true,
  actasAUCTIFF: false,
  vistasDinamicas: true,
  calendario_dinamico: false,
  calendario_dinamico_unico: true,
  searchByProcess: true,
  radicacion_cinco: true,
  secondary: true,
  hideRefreshForms: false,
  colorNavBarHeader: '#34495e',
  colorNavBarBody: '#2c3e50',
  version: env.npm_package_version,
  serverUrl: 'https://cita2-corpouraba-api.integracionweb.com.co/api',
  defaultLanguage: 'es-CO',
  showDebugHelpers: false,
  credentialsKey: 'credentials',
  securityKey: '@iae=8il2a_j#0rx@)ti9oi61egi+7)^',
  storage: {
    prefix: 'iw',
    separator: '-',
    caseSensitive: false
  },
  servers_integrations: {
    CITA: {
      SERVER: 'http://{}/',
      EDITORURL: 'https://editor.crc.gov.co/tiny/tinymce/js/tinymce/tinymce.min.js',
      PATH_INTERNAL: 'core/services/integracion_cinco/',
      PATH_DOWNLOAD: 'core/services/modulos/documentos/utils/',
      PATH_VIEW: 'integracion_cinco/',
      PATH_LIQUIDATION: 'core/services/integracion_cinco/liquidacion',
      ACTAS_MINISTERIO: 'acta_unica_ministerio/',
      NAME_FILES: {
        INDEX: 'index.php',
        DOWNLOAD_DOC: 'abrir_docto.php',
        VIEW_STICKER: 'RadicacionCinco.php',
        LIQUIDATION: {
          liquidation: 'liquidacion.php',
          liquidations: 'liquidaciones.php',
          generate: 'CrearLiquidacionCinco.php'
        },
        VIEW_MASK: ''
      },
      INDICES: false,
      ANEXOS: false
    },
    CINCO: {
      SERVER: 'https://cita2-corpouraba-api.integracionweb.com.co',
      PATHS: {
        SERVICES: '/services/'
      }
    }
  },
  whitelistedDomains: ['https://cita2-corpouraba-api.integracionweb.com.co/'],
  supportedLanguages: ['es-CO', 'en-US'],
  generateUserLogin: false,
  radicacionAvanzada: false,
  confRadicacionAvanzada: configuracion_radicacion_avanzada,
  specialAnulationRadication: false,
  radicadoRespuestaDe: true,
  previsulizacionDocumentos: true,
  previsualizacionGeneracionDocumento: true,
  stickersAvanzados: true,
  ValoracionDocumental: true,
  codigosGestionDocumental: true,
  visualizarCodigoTipoDocumental: true,
  DependenciasEstructuraDocumental: true,
  EscanerDocumentos:true,
  hiddenExpTypeDocument:false,
  autoRegistryExpTypeDocument:false,
  activarGenerarFinalizacion: false,
  hiddenExpSubserieDocument:false,
  hiddenAddNewExpDocument:false,
  hiddenAddNewExpSubserieDocument:false,
  DocumentExpCustom: true,
  changeTaskAssignationName: false,
  Helps: false,
  actasAUCTIFFCinco: false,
  googleAnalyticsId: '',
  showHistoryModificationDocument: true,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts